import { Flex } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SignatureCanvas from "react-signature-canvas";

export const Signature = (props) => {
  const sigCanvas = useRef(null);
  const { value, disabled } = props;
  const [imageURL, setImageURL] = useState(null);
  const [isEmpty, setIsEmpty] = useState(true);
  const { t } = useTranslation();

  // handle value string and File object
  useEffect(() => {
    if (value) {
      // Check if value is a string (URL from server)
      if (typeof value === "string") {
        setImageURL(value);
        setIsEmpty(false);
      }
      // Check if value is a File object (from save)
      else if (value instanceof File) {
        const url = URL.createObjectURL(value);
        setImageURL(url);
        setIsEmpty(false);

        // Cleanup: revoke object URL when component unmounts
        return () => URL.revokeObjectURL(url);
      }
    } else {
      // Reset if value becomes null/undefined
      setImageURL(null);
      setIsEmpty(true);
    }
  }, [value]);

  const clear = () => {
    sigCanvas?.current?.clear();
    setImageURL(null);
    setIsEmpty(true);
    props.onChange(null);
  };

  const save = async () => {
    if (sigCanvas.current.isEmpty()) {
      alert("Please provide a signature first");
      return;
    }

    // Use getCanvas() instead of getTrimmedCanvas()
    const canvas = sigCanvas.current.getCanvas();

    // Promisify toBlob
    const blob = await new Promise((resolve) => {
      canvas.toBlob(resolve, "image/png");
    });

    if (blob) {
      const file = new File([blob], "signature.png", { type: "image/png" });
      const url = URL.createObjectURL(blob);

      setImageURL(url);
      props.onChange(file);
    }
  };

  const handleEnd = () => {
    setIsEmpty(sigCanvas.current.isEmpty());
  };

  return (
    <div>
      {!imageURL && (
        <>
          <div
            style={{
              borderRadius: "10px",
              display: "inline-block",
              border: props.error ? "1px solid #ff4d4f" : "1px solid #ccc",
              ...(props?.style ?? {}),
            }}
          >
            <SignatureCanvas
              ref={sigCanvas}
              penColor="black"
              canvasProps={{
                width: "200px",
                height: "150px",
              }}
              onEnd={handleEnd}
            />
          </div>
          <>{props.error && <div className="text-danger">{props.error}</div>}</>
        </>
      )}

      {imageURL && (
        <div>
          <img
            src={imageURL}
            alt="Signature"
            style={{
              borderRadius: "10px",
              border: "1px solid #ccc",
              ...(props?.style ?? {}),
            }}
          />
        </div>
      )}

      {!disabled && <Flex align="center" gap={8} style={{ marginTop: "10px" }}>
        {!imageURL && (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={save}
            disabled={isEmpty}
          >
            {t("SAVE")}
          </button>
        )}
        <Button type="button" className="btn btn-danger btn-sm" onClick={clear}>
          {t("CLEAR")}
        </Button>
      </Flex>}
    </div>
  );
};
